import {
  CommonModule,
  CurrencyPipe,
  DecimalPipe,
  PercentPipe,
} from '@angular/common';
import { NgModule } from '@angular/core';
import { ContainersPipe } from './containers.pipe';
import { PopulationCategory } from './population-category.pipe';
import { ProgramTypePipe } from './program-type.pipe';
import { SafePipe } from './safe.pipe';
import { CurbsideContaminationPipe } from './curbside-contamination.pipe';
import { CartSizesPipe } from './card-sizes.pipe';
import { AdditionalServicesPipe } from './additional-service.pipe';
import { MethodsPipe } from './methods.pipe';

@NgModule({
  declarations: [PopulationCategory, SafePipe],
  imports: [
    CommonModule,
    ProgramTypePipe,
    ContainersPipe,
    CurbsideContaminationPipe,
    CartSizesPipe,
    AdditionalServicesPipe,
    MethodsPipe,
  ],
  providers: [
    ContainersPipe,
    DecimalPipe,
    CurrencyPipe,
    PercentPipe,
    CurbsideContaminationPipe,
    CartSizesPipe,
    AdditionalServicesPipe,
    MethodsPipe,
  ],
  exports: [
    PopulationCategory,
    SafePipe,
    ContainersPipe,
    ProgramTypePipe,
    CurbsideContaminationPipe,
    CartSizesPipe,
    AdditionalServicesPipe,
    MethodsPipe,
  ],
})
export class PipesModule {}
